import { FormValues } from '../../../integration-test-modal.types';

export const nestedObjectFieldUtils = {
  normalizeObjectValue: (value: FormValues): FormValues => {
    if (typeof value === 'object' && value !== null) {
      return value;
    }
    return {};
  }
};
